// 보호소 공유 일정(SHELTER_SCHEDULE) 공통 — 홈 캘린더·동물 상세·입양신청서 상세가 같이 씀
// 입력창은 App 에 하나(ScheduleFormModal): emitter 'openScheduleForm' { shelter_device_number, event(수정) | preset(새로) }
// 저장·삭제·완료 체크 후 emitter 'scheduleChanged' { notify_number, request_idx } → 각 화면이 다시 불러옴

//일정 구분 (서버 ScheduleController.CATEGORIES 와 같게). legacy = 예전 구분 — 입력창에는 안 보이고 기존 일정 색만
export const SCHEDULE_CATEGORIES = [
    { key: '입양', color: '#F6951C' },
    { key: '상담', color: '#3B82F6' },
    { key: '방문', color: '#22B07D' },
    { key: '접종예정', color: '#A855F7', legacy: true },     //접종 기록·키트 검사에서 입력 → 자동 표시라 입력창에선 뺌
    { key: '키트 재검사', color: '#EF4444', legacy: true },
    { key: '병원', color: '#6366F1' },   //인디고 (상담 파랑과 구분)
    { key: '입소', color: '#14B8A6' },
    { key: '봉사', color: '#84CC16' },   //연두 (입양 주황·방문 초록과 구분)
    { key: '행사', color: '#EC4899' },
    { key: '기타', color: '#94A3B8' },
    { key: '진료', color: '#6366F1', legacy: true },
];

//자동 항목 종류 (캘린더 필터·동물 일정 카드)
export const SCHEDULE_TYPES = [
    { key: 'schedule', label: '일정', color: '#3B82F6' },
    { key: 'vaccine', label: '접종 예정', color: '#A855F7' },
    { key: 'kit', label: '키트 재검사', color: '#EF4444' },
    { key: 'notice_end', label: '공고 종료', color: '#7B7F86' },
];

export function scheduleColor(e) {
    if (e.type == 'schedule') {
        const c = SCHEDULE_CATEGORIES.find(x => x.key == e.category);
        return c ? c.color : SCHEDULE_TYPES[0].color;
    }
    const t = SCHEDULE_TYPES.find(x => x.key == e.type);
    return t ? t.color : '#888';
}

export function scheduleTypeLabel(e) {
    if (e.type == 'schedule') return e.category || '일정';
    const t = SCHEDULE_TYPES.find(x => x.key == e.type);
    return t ? t.label : e.type;
}

const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'];

//'10월 23일 (금) · 14:00 ~ 15:00' — 요일은 직접 (moment.locale 은 전역이라 다른 화면에 영향)
export function scheduleWhen(e, moment) {
    const d = (s) => { const m = moment(s, 'YYYY-MM-DD'); return m.format('M월 D일') + ' (' + WEEKDAYS[m.day()] + ')'; };
    let t = d(e.date);
    if (e.end_date && e.end_date != e.date) t += ' ~ ' + d(e.end_date);
    if (e.time) t += ' · ' + e.time + (e.end_time ? ' ~ ' + e.end_time : '');
    else if (e.type == 'schedule') t += ' · 종일';
    return t;
}

//완료 체크 — 화면 먼저 바꾸고 실패하면 되돌림
export function toggleScheduleDone(vm, e, on) {
    const prev = e.done;
    e.done = on ? 'Y' : 'N';
    return vm.axios.put(`/shelter/schedule/${e.idx}/done`, { done: e.done })
        .then(res => {
            if (!res.data || res.data.result != 'YES') { e.done = prev; alert((res.data && res.data.resultMsg) || '변경하지 못했습니다.'); return; }
            vm.emitter.emit('scheduleChanged', { notify_number: e.notify_number, request_idx: e.request_idx, idx: e.idx });
        })
        .catch(() => { e.done = prev; alert('변경 중 오류가 발생했습니다.'); });
}

export function removeSchedule(vm, e) {
    if (!confirm(`'${e.title}' 일정을 삭제하시겠습니까?`)) return Promise.resolve(false);
    return vm.axios.delete(`/shelter/schedule/${e.idx}`).then(res => {
        if (res.data && res.data.result == 'YES') {
            vm.$root.showToastMsg('', '일정', '삭제되었습니다.', 'default');
            vm.emitter.emit('scheduleChanged', { notify_number: e.notify_number, request_idx: e.request_idx, idx: e.idx });
            return true;
        }
        alert((res.data && res.data.resultMsg) || '삭제하지 못했습니다.');
        return false;
    }).catch(() => { alert('삭제 중 오류가 발생했습니다.'); return false; });
}
